/**
 * Estado de la casa, DERIVADO de datos reales con regla honesta:
 * parada = sin actividad 14 días (el umbral del canon); onboarding = la casa
 * aún no ha aprendido NADA (ni criterios, ni decisiones, ni seguimientos);
 * activa = el resto. La regla vieja miraba solo los criterios y, con casas
 * reales, llamaba «onboarding» a 47 de 53 — también a las que ya habían
 * apuntado decisiones. Cuando el modelo tenga estados de ciclo propios
 * (OQ-10), esta regla se sustituye.
 */
import type { EngagementSummary } from "@skein/contracts";
import { diasDesde } from "./fecha";

export type EstadoCasa = "activa" | "onboarding" | "parada";
export function estadoDe(e: EngagementSummary, ahora = new Date()): EstadoCasa {
  if (e.ultimaActividad && diasDesde(e.ultimaActividad, ahora) >= 14) return "parada";
  if (e.criterios === 0 && e.decisiones === 0 && e.followUpsAbiertos === 0) return "onboarding";
  return "activa";
}
